import React, { FC, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";

import { Text } from "@/components/Text";
import { refresh } from "@/data/session";
import { putUser } from "@/data/users";
import { Flex, Switch } from "@/eworkitComponents";
import { PublicAnchor } from "@/router/PublicAnchor";
import { useToasts } from "@/views/components/Toast/useToasts";

import { IUserSectionProps } from "../UserName/types";

interface IDigitalCommunicationSectionProps extends IUserSectionProps {}

export const DigitalCommunicationSection: FC<IDigitalCommunicationSectionProps> = ({ record, onUpdate }) => {
  const { addToast } = useToasts();
  const { t } = useTranslation("common");

  const handleSwitchChange = useCallback(
    async value => {
      try {
        await putUser(
          { userId: record.id },
          { ...record, settings: { ...record.settings, digitalCommunicationEnabled: value } },
        );
        const sessionUser = await refresh();
        onUpdate?.(sessionUser);
      } catch (error) {
        addToast({
          text: t("VALIDATION_MESSAGES.GENERAL"),
          type: "warning",
        });
      }
    },
    [record, onUpdate, addToast, t],
  );

  return (
    <Flex direction="row" align="center">
      <Text>
        <Trans ns="session" i18nKey="USERS.SETTINGS.EMAIL_NOTIFICATIONS.OTHERS.DIGITAL_COMMUNICATION">
          <PublicAnchor page="PRIVACY-POLICY" target="_blank" className="-word-break-word" />
          <Text />
        </Trans>
      </Text>

      <Flex justify="flex-end" direction="row" grow={1}>
        <Switch value={record.settings?.digitalCommunicationEnabled} onChange={handleSwitchChange} />
      </Flex>
    </Flex>
  );
};
